import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import urls, { relativeUrl } from '@/constants/urls';

const UsersLauncherMenu = () => (
  <RibbonMenu
    name="users"
    icon="user"
    message="fair.launcher.users"
    url={`#${relativeUrl(urls.USERS)}`}
    className="aridhia-users-launcher-menu"
  />
);

export default UsersLauncherMenu;
